import React from 'react'
import Page from '../../components/Page'
import Navbar from '../../components/Navbar'

class Home extends React.Component {
    render () {
        return (
            <Page>
                <Navbar/>
            </Page>
        )
    }
}

export default Home